import groq from "groq";
import productGroupFields from "./productGroupFields";
import { applyFrench } from "@lib/applyFrenchField";

const internalLink = `
    _type == "internalLink" => {
        "type": @->_type,
        "slug": @->slug,
        "handle": @->store.slug.current,
        "id": @->_id,
        "productGroup": *[_type == "product" && ^->_id == _id] {
            "data": *[_type=='productPage' && references(^._id) ] {
                ${productGroupFields}
            }
        }[0],
    },
`;

const description = `${applyFrench(
  `description[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`,
  `description_fr.portableText[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`
)}`;

const fitDescription = `${applyFrench(
  `fitDescription[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`,
  `fitDescription_fr.portableText[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`
)}`;

export const bundle = () => groq`
*[_type == "bundle" && slug.current == $slug] | order(_updatedAt desc) {
    'type': _type,
    "title": ${applyFrench("title", "title_fr")},
    slug,
    bundleType,
    "discountMessage": ${applyFrench("discountMessage", "discountMessage_fr")},
    "description": ${description},
    sections[] {
        "key": _key,
        "sectionTitle": ${applyFrench("sectionTitle", "sectionTitle_fr")},
        productGroups[] {
            productReference -> {
                ...,
                sizeGuide {
                    "fitDescription": ${fitDescription},
                    body {
                        ...,
                        "title": ${applyFrench("title", "title_fr")},
                        "data": sizeChartReference->chart.data {
                            ...,
                        },
                        "img": sizeChartReference->bodyImage {
                            ...,
                        }
                    },
                    garment {
                        ...,
                        "title": ${applyFrench("title", "title_fr")},
                        "garmentImage": {
                            ...,
                            "altText": ${applyFrench("altText", "altText_fr")}
                        }
                    }
                },
                shopifyProducts[] {
                    productColour -> {
                        ...,
                    },
                    productReferenceV2 -> {
                        ...,
                        "id": store.id,
                        "handle": store.slug.current,
                        "title": store.title,
                        "tags": store.tags,
                        "type": store.productType,
                    },
                },
            },
        },
    },
    images[] {
        ...,
    }
}[0]`;
